// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federgeraeusch/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federgeraeuschDE: PageEntry = {
  id: "post.federgeraeusch",
  locale: "de",
  slug: "federgeraeusch",
  seo: {
    title: "Glossar: Federgeräusch einfach erklärt | Dietz GmbH",
    description: "Federgeräusche sind die akustischen Emissionen, die während der Bewegung oder Verformung einer Feder auftreten können. Diese Geräusche entstehen durch Reibung, Vibrationen oder Res",
  },
  type: "post",
  h1: "Glossar: Federgeräusch einfach erklärt",
  intro: "Federgeräusche sind die akustischen Emissionen, die während der Bewegung oder Verformung einer Feder auftreten können. Diese Geräusche entstehen durch Reibung, Vibrationen oder Resonanzen in der Feder oder den benachbarten Bauteilen. Um Federgeräusche zu minimieren, ist eine präzise Federkonstruktion, hochwertige Materialien und gegebenenfalls die Anwendung von Schmiermitteln oder Dämpfungselementen erforderlich. In vielen Anwendungen, insbesondere in der Automobilindustrie, ist die Kontrolle von Federgeräuschen entscheidend für den Komfort und die Qualität des Produkts.",
  blocks: [

  ],
};
